import React, { useEffect, useState } from "react";
import {
  Paper,
  Grid,
  TextField,
  MenuItem,
  Button,
  Box,
  Typography,
} from "@mui/material";

import {
  getCheckListForRmById,
  getEmpDocument,
  getResignationId,
  postKTchecklistApprove,
} from "../../../api/resignationCheckliistAssign";

import { useDispatch, useSelector } from "react-redux";
import { handleAxiosError } from "../../../config/action-config";
import { useNavigate, useParams } from "react-router-dom";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { showAlert } from "../../../actions/alert";

export default function KTChecklistReceivedForm({
  setEmployeeId,
  setReportingManager,
  setResgStatus,
  latestStatus,
}) {
  const params = useParams();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [projectsArray, setProjectArray] = useState([]);
  const [ktInitiatedFor, setKtInitiatedFor] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    getCheckListForReportingManagerById();
  }, []);
  async function getCheckListForReportingManagerById() {
    try {
      const { data } = await getCheckListForRmById(params.id, user.token);
      if (data.data.length !== 0) {
        const uniqueProjects = Object.values(
          data.data.reduce((acc, item) => {
            acc[item.project_id] = item;
            return acc;
          }, {})
        );
        setProjectArray([...uniqueProjects]);
        setKtInitiatedFor(data.data[0].emp_name);
        setEmployeeId(data.data[0].emp_id);
        setReportingManager(data.data[0].reporting_manager);
        setResgStatus(data.data[0].status);
      }
    } catch (error) {
      console.log("eroor3", error);
      handleAxiosError(error, dispatch);
    }
  }

  const onFormChange = (event, index) => {
    const { name, value } = event.target;
    const updatedProjectsArray = [...projectsArray];
    updatedProjectsArray[index] = {
      ...updatedProjectsArray[index],
      [name]: value,
    };
    setProjectArray(updatedProjectsArray);
  };

  async function onSubmit() {
    const combinedData = extractedKeys(projectsArray, user.firstname);
    try {
      const { data } = await postKTchecklistApprove(user.token, {
        data: combinedData,
      });
      dispatch(showAlert(data.msg));
      navigate("/resignation-request");
      // navigate("/resignation-checklist");
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  const handleDocClick = async (id) => {
    console.log(id, "id");
    if (loading) {
      return;
    }

    setLoading(true);

    try {
      const token = user.token;
      const blob = await getEmpDocument(id, token);
      const fileURL = window.URL.createObjectURL(blob.data);

      setLoading(false);
      window.open(fileURL, "_blank");
    } catch (err) {
      setLoading(false);
      handleAxiosError(err, dispatch);
    }
  };

  return (
    <Paper sx={{ p: 2 }}>
      {/* {params?.status === "KT_APPROVED" && (
        <Typography sx={{ pb: 2 }}>
          Now, you can verify the credential checklist for further process.
        </Typography>
      )} */}

      {/* {params?.status === "CREDENTIALS_CHECKLIST_APPROVED" && <></>} */}

      <Grid sx={{ pb: 2 }} container spacing={2} alignItems="center">
        <Grid item xs={6}>
          <TextField
            fullWidth
            value={ktInitiatedFor}
            label="KT initiated for"
            disabled
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            value={user.firstname}
            label="Approved By"
            disabled
          />
        </Grid>
      </Grid>
      {projectsArray.map((project, index) => (
        <Box
          key={index}
          sx={{
            border: 2,
            borderColor: "primary.main",
            borderRadius: 5,
            p: 2,
            mb: 2,
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.5)",
          }}
        >
          <Box sx={{ mb: 2 }}>
            <Typography
              variant="h8"
              style={{ fontWeight: "bold", color: "#08459c" }}
            >
              Project Name: {project.project_name}
            </Typography>
          </Box>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={3}>
              <TextField
                fullWidth
                disabled
                name="handover_to"
                label="KT Handover To"
                value={project.handover_to}
              ></TextField>
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                disabled
                label="KT Assigned Date"
                name="assign_date"
                value={formatDateToYYYYMMDD(project.assign_date)}
                onChange={(event) => onFormChange(event, index)}
                type="date"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                disabled
                name="completion_date"
                value={formatDateToYYYYMMDD(project.completion_date)}
                label="KT Completion Date"
                type="date"
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                select
                disabled
                name="document_completion"
                label="Documentation Completed"
                value={project.document_completion}
                onChange={(event) => onFormChange(event, index)}
              >
                <MenuItem value="">Select</MenuItem>
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                name="documentation_remarks"
                label="Documentation Remarks"
                disabled
                value={project.documentation_remarks}
                onChange={(event) => onFormChange(event, index)}
                multiline
                rows={2}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                fullWidth
                name="manager_remarks"
                label="Reporting Manager Remarks"
                value={project.manager_remarks}
                onChange={(event) => onFormChange(event, index)}
                multiline
                rows={2}
              />
            </Grid>
            <Grid item xs={3}>
              <TextField
                fullWidth
                value={formatDateToYYYYMMDD(project.approval_date)}
                onChange={(event) => onFormChange(event, index)}
                type="date"
                name="approval_date"
                label="approval Date"
              />
            </Grid>
            <Grid item xs={3}>
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleDocClick(project.id);
                }}
                style={{
                  textDecoration: "none",
                  color: "inherit", // Inherit color from parent
                }}
              >
                <span
                  style={{
                    textDecoration: "underline",
                    color: "blue",
                    marginLeft: "5px",
                  }}
                >
                  {project?.document_file}
                </span>
              </a>
            </Grid>
            {/* <Grid item xs={12} sm={12} md={12} lg={12}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  onClick={(e) => {
                    e.preventDefault();
                    handleDocClick(project.id);
                  }}
                  variant="contained"
                  style={{ padding: "5px 7px" }}
                  className="blue-button"
                >
                  Document Preview
                </Button>
              </Box>
            </Grid> */}

            <Grid item xs={12}></Grid>
          </Grid>
        </Box>
      ))}

      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "right",
            columnGap: 1,
            ml: "auto",
          }}
        >
          <Button
            variant="contained"
            onClick={() => {
              navigate(-2);
            }}
            className="blue-button"
          >
            CANCEL
          </Button>
          {latestStatus === "KT_SUBMITTED" && (
            <Button
              variant="contained"
              onClick={onSubmit}
              type="submit"
              style={{ padding: "5px 7px" }}
              className="blue-button"
            >
              SUBMIT
            </Button>
          )}
        </Box>
      </Grid>
    </Paper>
  );
}
function formatDateToYYYYMMDD(isoDateString) {
  if (!isoDateString) return ""; // Return empty string if input is falsy

  const datePortion = isoDateString.split("T")[0];
  return datePortion;
}
function extractedKeys(data, approvedBy) {
  return data.map((item) => ({
    id: item.id,
    emp_id: item.emp_id,
    handover_to: item.handover_to,
    manager_remarks: item.manager_remarks,
    approved_by: approvedBy,
    approval_date: item.approval_date,
  }));
}
